import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import metadata from './MLEmployersAffiliationsNonServicingStatesCardComponent.metadata.json5'
import messages from './MLEmployersAffiliationsNonServicingStatesCardComponent.messages';
import styles from './MLEmployersAffiliationsNonServicingStatesCard.module.scss';

function MLEmployersAffiliationsNonServicingStatesCardComponent(props){
    const translator = useTranslator();


    const overrides = {
        retrySearch: {
            content: translator(messages.retrySearch)
        },
        skipDiscount: {
            content: translator(messages.skipDiscount)
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={{}}
            classNameMap={styles}
            overrideProps={overrides}
            showErrors={false}
        />
    );    
}

export default MLEmployersAffiliationsNonServicingStatesCardComponent;